import { createContext, useContext } from 'react';

import type { PropsFromWithSkillSetSaving } from 'bundles/program-home/components/ProgramHomeApp';

export type EnterpriseUserSkillProfileContextType = PropsFromWithSkillSetSaving;

const EnterpriseUserSkillProfileContext = createContext<EnterpriseUserSkillProfileContextType>({
  userSkillProfileStates: [],
  userSkillProfileStatesLoading: false,
  onSkillSetSaveToggle: () => Promise.resolve(),
  shouldRefetchUserSkillProfileStates: false,
  setShouldRefetchUserSkillProfileStates: () => undefined,
  finishedSkillsets: [],
});

export const useUserSkillProfile = () => useContext(EnterpriseUserSkillProfileContext);

export default EnterpriseUserSkillProfileContext;
